import React, { useState } from 'react'
import { Modal, ModalBody } from "react-bootstrap";
import ModalHeader from '../../../../../../../Setup/Shared/ModalHeader';
import FormValidator from '../../../../../../../../utils/FormValidator';
import { enumUtil } from '../../../../../../../../utils/Enum';
import NotificationHandler from '../../../../../../../../utils/NotificationHandler';
import Loader from '../../../../../../../shared/Loader/Loader';

const AddAddendum = ({addendumModal, setAddendumModal, saveAddendumData, setSaveAddendumData, ...props}) => {
  console.log("AddAddendumM", saveAddendumData)
  // const API_URL = enumUtil.controller.Dashboard;
  let valModal = {}
  let ValidationModal = {
    NotesVal: "",
  }
  let Addendum_Modal = {            
    EncounterAddendumID : "",
    Deleted : "false",
    Notes: "",
  }
  const [isLoading, setIsLoading] = useState(false)
  const [advanceDirectivesValidationModal, setAddendumValidationModal] = useState(ValidationModal);
  const [mainAddendumModal, setMainAddendumModal] = useState(Addendum_Modal);
  
  const AddendumValidation = async () => {
    let ValidationModal = {
      NotesVal: FormValidator(
        mainAddendumModal.Notes,
        enumUtil.enumValidationType.Required,
        'Notes',
      ),

    }
    await setAddendumValidationModal(ValidationModal)
    valModal = ValidationModal
  }
  const handleChange = (e) => {
    let { name, value } = e.target
    let modal = { ...mainAddendumModal };
    // let saveModal = { ...advanceDirectivesSaveUpdateModal }
    modal[name] = value
    // setSaveAddendumData(modal);
    setMainAddendumModal(modal)
    // for (var property in Addendum_Modal) {
      // if (name === property) {
        // saveModal[name] = value
      // }
    // }
  }

  const AddendumName = () => {
    return (
      <p className="heading">Add Addendum</p>
    )
  }

  const handleSaveAddendum = async() => {
    await AddendumValidation();
    let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    if (validation) {
      NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
      return
    } else {
      setIsLoading(true);
      setSaveAddendumData([mainAddendumModal])
      props?.getSaveData?.();
      // onClose();
      setIsLoading(false);
      // setAdvanceDirectivesSaveUpdateModal(advanceDirectivesSaveUpdateModal)
      // let saveModal = {
      //   TableName: enumUtil.enumAPITableName.PatientAdvanceDirectives,
      //   // ID: advanceDirectivesID,
      //   // data: { PatientID: PatientIDR, ...advanceDirectivesSaveUpdateModal },
      //   value: null
      // }
      // setIsLoading(true)
      // ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
      //   .then((response) => {
      //     if (!isNull(response.id)) {
      //       setIsLoading(false)
      //       NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
      //       // props.setIsRecordSaved(true);
      //       // if (type === "Add Another") {
      //       //   addNewAdvanceDirectives();
      //       // } else {
      //         onClose();
      //       // }
      //     }
      //   }).catch((error) => {
      //     setIsLoading(false)
      //     NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
      //   })
    }
  }

  const onClose = () => {
    setAddendumModal(false);
  }

  return (
    // <Modal show={addendumModal} onHide={addendumModal} backdrop="static" keyboard={false} centered dialogClassName="ar_encounter_print_modal ar_encounter_main_screen ar_encounter_preview_sceen p-0 hk-modal-v1 table-default-design bg-transparent" >
    <Modal show={addendumModal} onHide={addendumModal} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
      <Modal.Body>
        {/* {DeleteConfirmation} */}
        {isLoading && <Loader />}
        <ModalHeader HeaderName={AddendumName} DeletePopup={""} isClosed={onClose} />
        <div className="">
           <div className={`input my-2 
            ${advanceDirectivesValidationModal.NotesVal ? 'error' : ''}
            `}>

            <label className="pb-3px">Notes</label>
            <textarea
              className="form-control overflow-hidden"
            //   ref={textareaRef}
            //   onInput={adjustTextareaHeight}
              rows="5"
              name="Notes"
              id="Notes"
              value={mainAddendumModal?.Notes}
              onChange={handleChange}
            ></textarea>
            {advanceDirectivesValidationModal.NotesVal}
          </div>
        </div>
      </Modal.Body>

      <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
        <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
        <div className="d-flex align-items-center gap-2">
          {/* <button className='btn btn-outline  px-10 h-100 validate-color' onClick={() => handleSaveAddendum("Add Another")}>Save & Add Another</button> */}
          <button className='btn btn-validate px-10 h-100' onClick={handleSaveAddendum}>Save</button>
        </div>
      </div>
    </Modal>
  )
}

export default AddAddendum